import {
    GET_CUSTOMER_ACCOUNT_STATEMENT_REQUEST,
    GET_CUSTOMER_ACCOUNT_STATEMENT_SUCCESS,
    GET_CUSTOMER_ACCOUNT_STATEMENT_ERROR 
} from "../actions/types"
export default function (state = [], action) {
    const { type, payload } = action;
    switch (type) {

        case GET_CUSTOMER_ACCOUNT_STATEMENT_REQUEST:
            return {
                loading: true,
            };
        case GET_CUSTOMER_ACCOUNT_STATEMENT_SUCCESS:
            return {
                ...state,
                loading: false,
                payload,
            };
        case GET_CUSTOMER_ACCOUNT_STATEMENT_ERROR:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
}